export const VISUAL_LISTING = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.VisualListingWidgetElement';
